import * as React from 'react';
import { AppSettingContext, AppSettingContextData } from '@contexts/appSetting/AppSettingContext';

export const useAppSetting = (): AppSettingContextData => React.useContext(AppSettingContext);
